import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Form, ListGroup, Modal } from "react-bootstrap";
import Layout from "../../components/Layout";
import { DE } from "../../Languages/DE";
import { EN } from "../../Languages/EN";
import LanguageContext from "../../helper/LanguageContext";
import { callAPI } from "../../helper/apiUtils";
import { Scrollbars } from "react-custom-scrollbars";
import { BASE_URL, goBack } from "../../helper/constants";
import { $crud } from "../../helper/CrudFactory";
import { Positions } from "../../Languages/vars/Positions";
import { ReactComponent as AddSvg } from "../../Icons/Add.svg";
import { Animated } from "react-animated-css";
import { convertRole } from "../../helper/convertor";
import "./company.css";

const renderThumb = ({ style, ...props }) => {
  const thumbStyle = {
    borderRadius: 6,
    backgroundColor: "rgba(var(--kjuup-accent-rgb), 0.8)",
  };
  return (
    <div
      className="thumb-style"
      style={{ ...style, ...thumbStyle }}
      {...props}
    />
  );
};

const CustomScrollbars = (props) => (
  <Scrollbars
    renderThumbHorizontal={renderThumb}
    renderThumbVertical={renderThumb}
    {...props}
  />
);

function Company(props) {

  const { isGerm, strings } = React.useContext(LanguageContext);
  const history = useHistory();
  const [companies, setCompanies] = useState([]);
  const [allCompanies, setAllCompanies] = useState([]);
  const [employeePosition, setEmployeePosition] = useState();
  const [showPositionDialog, setPositionDialog] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const hidePositionDialog = () => setPositionDialog(false);
  const [company, setCompany] = useState({});
  const positions = Positions;
  const getCompanies = async () => {
    const { data } = await callAPI(
      `/company/getAllRegCompaniesForHome`,
      {
        page,
        limit,
        lang: "en",
      },
      "GET"
    );
    if (data.status) {
      setCompanies(data.companies);
      setAllCompanies(data.companies);
    }
  };
  useEffect(() => {
    getCompanies();
  }, []);

  const getCompanyDetails = (id) => {
    history.push({
      pathname: "/foreign-company-details/" + id,
      state: { id: id },
    });
  };
  const companyFilter = (value) => {
    console.log(value);
    setSearch(value);
    const filterCompanies = companies.filter((company) => {
      if (value === "") {
        return company;
      } else if (company.name?.toLowerCase().includes(value?.toLowerCase())) {
        return company;
      }
    });
    if (value === "") {
      console.log(allCompanies);
      setCompanies(allCompanies);
    } else {
      setCompanies(filterCompanies);
    }
    console.log(filterCompanies);
  };
  const handleSubmit = async () => {
    console.log(employeePosition);
    if (!employeePosition) {
      await $crud.notify({
        type: "error",
        message: strings.please_select_position,
      });
    } else {
      const params = {
        name: company.name,
        email: company.email,
        corporateForm: company.corporateForm,
        branch: company.branch,
        street: company.street,
        postCode: company.postCode,
        city: company.city,
        country: company.country,
        lat: company.lat,
        long: company.long,
        position: employeePosition,
      };
      console.log(params);
      const { data } = await callAPI("/company", params, "POST");
      setPositionDialog(false);
      $crud.notify({
        type: data.status ? "success" : "error",
        message: data.message,
      });
      getCompanies();
    }
  };
  const [visible, setVisible] = useState(true);
  const handleBack = () => {
    setVisible(false);
    setTimeout(() => {
      goBack();
    }, 1000);
  };
  return (
    <React.Fragment>
      <Layout>
        <Animated
          animationIn="slideInLeft"
          animationOutDuration={800}
          isVisible={true}
        >
          <div class="company_section w-300 company_list">
            <div className="company_header company_border company-page__header">
              <div class="heading_icon">
                <div>
                  <a onClick={handleBack} className="main_heading pointer">
                    {" "}
                    <img
                      width={10}
                      src={process.env.PUBLIC_URL + "/assets/img/back.svg"}
                    />
                    {strings.company_list}
                  </a>
                </div>
                <div className="icons_heading">
                  <Link to="/add-company">
                    <img
                      width={18}
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/img/Add-Company-PP.svg"
                      }
                    />
                  </Link>
                  <a href="#">
                    <img
                      width={18}
                      src={process.env.PUBLIC_URL + "/assets/img/Location.svg"}
                    />
                  </a>
                </div>
              </div>
              <div className="search">
                <Form.Group controlId="exampleForm.ControlInput1">
                  <Form.Control
                    autocomplete="off"
                    type="search"
                    placeholder={strings.search}
                    onChange={(e) => companyFilter(e.target.value)}
                  />
                </Form.Group>
              </div>
            </div>
            <div className="my-scroll profile_height m-0">
              <CustomScrollbars
                autoHide
                autoHideTimeout={500}
                autoHideDuration={200}
                className="bottom-bar"
              >
                <div className="company_list_ver">
                  {companies &&
                    companies.map((company) => (
                      <div className="bg-purple" key={company.id}>
                        <div className="row">
                          <div className="col-md-5 pr-0">
                            <div className="user_profile">
                              <div className="user_img">
                                <a href="#">
                                  {company.logo ? (
                                    <img
                                      width={40}
                                      height={40}
                                      src={BASE_URL + company.logo}
                                      alt="Generic placeholder"
                                    />
                                  ) : (
                                    <div className="company_img_placeholder" aria-hidden="true">
                                      <span className="material-symbols-outlined">image</span>
                                    </div>
                                  )}
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-5 pl-0">
                            <div className="follow">
                              <div className="follow_item text-center">
                                <h5>{company.articleCount}</h5>
                                <p>{strings.article}</p>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-2 text-right">
                            <AddSvg
                              onClick={(e) => {
                                setPositionDialog(true);
                                setEmployeePosition("");
                                setCompany(company);
                              }}
                              className="mt-1 mr-1 pointer custom-svg"
                              height={21}
                            />
                          </div>
                        </div>
                        <div className="profile-flied p-0">
                          <div className="profile_name">
                            <h3
                              className="pointer"
                              onClick={(e) => getCompanyDetails(company.id)}
                            >
                              {company.name}
                            </h3>
                            {company.owner ? (
                              <p>{strings.owner_company_admin_new} : {company.owner}</p>
                            ) : (
                              ""
                            )}
                            <p>{convertRole(company.branch,isGerm)}</p>
                            <p>
                              {company.street}, {company.postCode},{" "}
                              {company.city}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </CustomScrollbars>
            </div>
          </div>
        </Animated>
        <Modal
          show={showPositionDialog}
          onHide={hidePositionDialog}
          animation={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>{strings.your_position_within_company}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ListGroup variant="flush">
              {positions.map((position) => (
                <div
                  onClick={(e) => setEmployeePosition(position.name_en)}
                  key={position.id}
                  className="form-check p"
                >
                  <input
                    className="form-check-input"
                    type="radio"
                    name="exampleRadios"
                    id={position.id}
                    value={position.name_en}
                  />
                  <label
                    className="form-check-label pointer"
                    htmlFor={position.id}
                  >
                    {isGerm ? position.name_de : position.name_en}
                  </label>
                </div>
              ))}
            </ListGroup>
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="kj-btn kj-btn--secondary" onClick={hidePositionDialog}>
            {strings.close_modal}
            </button>
            <button type="button" className="kj-btn kj-btn--outline" onClick={handleSubmit}>
              {strings.ok}
            </button>
          </Modal.Footer>
        </Modal>
      </Layout>
    </React.Fragment>
  );
}

export default Company;
